module.exports = __webpack_public_path__ + "static/img/bg-1.cd35ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/bg-1.png
// module id = q8hM
// module chunks = 0